module.exports = __webpack_public_path__ + "img/AGBlackGCrop.c73abc9c.png";